export const roundUpToTwoDecimals = (price: number): number =>
  Math.ceil(price * 100) / 100;
